import { UIElement } from '../ui-element';

export class SeekIndicatorValueElement extends UIElement {
  static readonly tagName = 'media-seek-indicator-value';
}
